/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CallDealerModal_viewer = {
    readonly viewerUser?: {
        readonly profile: {
            readonly displayName: string | null;
        } | null;
    } | null;
    readonly primaryPhone?: {
        readonly countryCodeNumber: string | null;
        readonly formattedPhoneNumber: string | null;
        readonly isActive: boolean | null;
    } | null;
    readonly " $refType": "CallDealerModal_viewer";
};
export type CallDealerModal_viewer$data = CallDealerModal_viewer;
export type CallDealerModal_viewer$key = {
    readonly " $data"?: CallDealerModal_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CallDealerModal_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "viewerUser",
          "args": (v0/*: any*/),
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "preventEmailFallback",
                      "value": true
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": "displayName(preventEmailFallback:true)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "Phone",
          "kind": "LinkedField",
          "name": "primaryPhone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCodeNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formattedPhoneNumber",
              "storageKey": null
            },
            {
              "alias": "isActive",
              "args": [
                {
                  "kind": "Literal",
                  "name": "status",
                  "value": "ACTIVE"
                }
              ],
              "kind": "ScalarField",
              "name": "hasStatus",
              "storageKey": "hasStatus(status:\"ACTIVE\")"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = '2da1eed11b0f7b3657b9a53ca33226d8';
export default node;
